export default __webpack_public_path__ + "locales/zh-CN/Files.json?hash=9afc2979ffef5046f63b6acac6b5e619";